import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-940b74ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center m-2 rounded text-white"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Ninja-bot", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "pi pi-angle-double-right"
}
const _hoisted_5 = {
  key: 1,
  class: "pi pi-angle-double-left"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!

  return (_openBlock(), _createBlock(_component_SidebarMenu, {
    menu: this.menuItems,
    width: "22em",
    showOneChild: true,
    "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event) => {
        this.collapsed = $event

        if (this.collapsed) {
          this.$emit('closed')
        }
      }),
    collapsed: false,
    "show-child": false,
    "disable-hover": true,
    onClick: _cache[1] || (_cache[1] = ($event) => {
        const isClickedByMenuItem =
            $event.srcElement.parentElement.classList.contains('vsm--link') ||
            $event.srcElement.parentElement.classList.contains('vsm--title') ||
            $event.srcElement.parentElement.classList.contains('vsm--item')

        if (isClickedByMenuItem) {
          this.$emit('closed')
        }
      })
  }, {
    header: _withCtx(() => [
      (!this.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    "toggle-icon": _withCtx(() => [
      (this.collapsed)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4))
        : (_openBlock(), _createElementBlock("p", _hoisted_5))
    ]),
    _: 1
  }, 8, ["menu"]))
}